import React, { useEffect, useState } from 'react'

const useInternetcheck = () => {
    const [isOnline,setisOnline]=useState(navigator.onLine);
    useEffect(() => {
        const handleOnline = () => setisOnline(true);
        const handleOffline = () => setisOnline(false);
    
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
    
        return () => {
          window.removeEventListener("online", handleOnline);
          window.removeEventListener("offline", handleOffline);
        };
      }, []);
  return isOnline
}

export default useInternetcheck

